/**
 * Share path from Rails to Webpack.
 *
 * If you're not sure which one to use, you can either look for it by using the Rails console
 * (`rails c` in terminal) or visit a random page where you would expect a 404: on development, it
 * will throw a Routing error page listing all possible url helpers.
 *
 * And don't forget to add your new paths to the unit test.
 */





export const DOMAIN = 'on-running.com'
export const CUSTOMER_SERVICE_SUBDOMAIN = `customer-service.${DOMAIN}`
export const PATH_ID_PLACEHOLDER = "PATH_ID_PLACEHOLDER"

// IMPORTANT: the url helpers will always return the path starting with a "/"
export const CHECKOUT_PATH = "/checkout"
export const FILTER_PAGE_PATH = "/explore"
export const FILTER_PAGE_MENS_PATH = `${FILTER_PAGE_PATH}/mens`
export const FILTER_PAGE_WOMENS_PATH = `${FILTER_PAGE_PATH}/womens`
export const SHOE_FINDER_PATH = "/shoe-finder"
export const SHIPPING_RETURNS_PATH = '/shipping_and_returns'
export const TERMS_AND_CONDITIONS = '/terms_and_conditions'
export const RAFFLE_FAQ_PATH = "/articles/faq-the-roger-clubhouse-prerelease"
export const ORDER_STATUS_PATH = '/order-status'
export const RETURNS_DIRECT_PATH = '/returns/direct'
export const PDP_PATH = "/products/PATH_ID_PLACEHOLDER"
export const PDP_ROGER_PATH = "/products/theroger-centre-court"
export const CYCLON_FAQ_PATH = "/articles/faq-your-questions-answered"
export const GIFT_CARDS_FAQS = "/articles/faq-digital-gift-card"
export const GIFT_CARDS_VIRT_PATH = '/gift-card'
export const ARTICLES_CATEGORY_PATH = "/articles/category/PATH_ID_PLACEHOLDER"
